<!-- Page Banner -->
<div class="page-banner-area item-bg4">
    <div class="container">
        <div class="page-banner-content">
            <h2>Contact Us</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Contact Us</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- Contact Info Area -->
<section class="contact-info-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="contact-info-box">
                    <div class="icon">
                        <i class="flaticon-email-1"></i>
                    </div>
                    <h3>Email Here</h3>
                    <p><a href="mailto:{{env.email}}">{{env.email}}</a></p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="contact-info-box">
                    <div class="icon">
                        <i class="flaticon-pin"></i>
                    </div>
                    <h3>Location Here</h3>
                    <p><a href="https://www.google.com/maps/@24.9045273,91.8523559,15z"
                            target="_blank">{{env.location}}</a></p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="contact-info-box">
                    <div class="icon">
                        <i class="flaticon-call"></i>
                    </div>
                    <h3>Call Here</h3>
                    <p><a href="tel:{{env.phone}}">{{env.phone}}</a></p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Contact Info -->

<!-- Contact -->
<section class="contact-area pb-100">
    <div class="container">
        <div class="section-title">
            <span>Get in Touch</span>
            <h2>Ready to Get Started?</h2>
            <div class="bar"></div>
        </div>

        <div class="contact-form">
            <form id="contactForm" [formGroup]="contactForm" (ngSubmit)="onSubmit()">
                <div class="row">
                    <div class="col-lg-6 col-md-6">
                        <div class="form-group mb-3">
                            <label>Name*</label>
                            <input type="text" class="form-control" formControlName="Name" maxlength="45"
                                [ngClass]="f.Name.touched || submitted? f.Name.errors? 'is-invalid': 'is-valid':''">
                            <div *ngIf="(f.Name.touched ||submitted) && f.Name.errors" class="invalid-feedback">
                                <div *ngIf="f.Name.errors.required">Name is required</div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="col-lg-6 col-md-6">
                        <div class="form-group mb-3">
                            <label>Last Name*</label>
                            <input type="text" name="name" id="name" class="form-control">
                        </div>
                    </div> -->

                    <div class="col-lg-6 col-md-6">
                        <div class="form-group mb-3">
                            <label>Your Email*</label>
                            <input type="email" class="form-control" formControlName="Email" maxlength="100"
                                [ngClass]="f.Email.touched || submitted? f.Email.errors? 'is-invalid': 'is-valid':''">
                            <div *ngIf="(f.Email.touched ||submitted) && f.Email.errors" class="invalid-feedback">
                                <div *ngIf="f.Email.errors.required">Email is required</div>
                                <div *ngIf="f.Email.errors.email">Email ID is invalid</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="form-group mb-3">
                            <label>Your Phone*</label>
                            <input type="text" class="form-control" formControlName="Phone" maxlength="45"
                                [ngClass]="f.Phone.touched || submitted? f.Phone.errors? 'is-invalid': 'is-valid':''">
                            <div *ngIf="(f.Phone.touched ||submitted) && f.Phone.errors" class="invalid-feedback">
                                <div *ngIf="f.Phone.errors.pattern">Phone is invalid</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="form-group mb-3">
                            <label>Your Subject*</label>
                            <input type="text" class="form-control" formControlName="Subject" maxlength="200"
                                [ngClass]="f.Subject.touched || submitted? f.Subject.errors? 'is-invalid': 'is-valid':''">
                            <div *ngIf="(f.Subject.touched ||submitted) && f.Subject.errors" class="invalid-feedback">
                                <div *ngIf="f.Subject.errors.required">Subject is required</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 col-md-12">
                        <div class="form-group mb-3">
                            <label>Your Message*</label>
                            <textarea class="form-control" cols="30" rows="5" formControlName="Message" maxlength="1000"
                                [ngClass]="f.Message.touched || submitted? f.Message.errors? 'is-invalid': 'is-valid':''"></textarea>
                            <div *ngIf="(f.Message.touched ||submitted) && f.Message.errors" class="invalid-feedback">
                                <div *ngIf="f.Message.errors.required">Message is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12">
                        <ngx-recaptcha2 #captchaEle [siteKey]="siteKey" formControlName="recaptcha"></ngx-recaptcha2>
                    </div>
                    <div class="col-lg-12 col-md-12">
                        <button *ngIf="!loader" type="submit" [disabled]="!contactForm.valid" class="default-btn">Send
                            Message</button>
                        <button *ngIf="loader" class="default-btn" type="button" disabled>
                            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                            Sending...
                        </button>
                    </div>
                </div>
            </form>
            <div class="alert " [ngClass]="classType">
                <strong>{{messageType}}</strong> {{message}}
            </div>
        </div>
    </div>
</section>
<!-- End Contact -->